"use client";

import { c as _c } from "react/compiler-runtime";
import { AlertTriangle, X } from "lucide-react";
import { usePathname } from "next/navigation";
import { Button } from "@defuse/ui/button";
import { LinkWithLoader } from "@/components/route-loader";
import { Short } from "@/components/short";
import { cn } from "@/lib/utils";

/**
 * Shown in place of the part of the page whose query failed, so the rest of the
 * page still renders.
 */
export function QueryFailed(t0) {
  const $ = _c(16);
  const {
    what,
    correlationId,
    align: t1,
    offerClearFilters: t2
  } = t0;
  const align = t1 === undefined ? "center" : t1;
  const offerClearFilters = t2 === undefined ? false : t2;
  const pathname = usePathname();
  const t3 = align === "left" ? "items-start" : "items-center";
  let t4;
  if ($[0] !== t3) {
    t4 = cn("text-destructive flex flex-col gap-1 py-4 text-sm", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AlertTriangle className="h-4 w-4 shrink-0" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== what) {
    t6 = <div className="flex items-center gap-1.5">{t5}<span>Error loading {what}</span></div>;
    $[3] = what;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== align || $[6] !== correlationId) {
    t7 = correlationId !== null && correlationId !== "" && <span className={cn("text-muted-foreground flex flex-wrap items-center gap-1.5", align === "left" ? "justify-start" : "justify-center")}>Try reloading the page or send this ID to us:<Short text={correlationId} length={correlationId.length} /></span>;
    $[5] = align;
    $[6] = correlationId;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== offerClearFilters || $[9] !== pathname) {
    t8 = offerClearFilters && <Button asChild={true} size="sm" variant="outline" className="mt-2"><LinkWithLoader href={pathname} scroll={false}><X className="h-4 w-4" />Clear all filters and retry</LinkWithLoader></Button>;
    $[8] = offerClearFilters;
    $[9] = pathname;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <div role="alert" className={t4}>{t6}{t7}{t8}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}